module.exports = __webpack_public_path__ + "static/media/client-grab.57050f6c.png";